import type { ColumnFilter, ColumnFilters } from './filters';
import { COLUMN_LABELS, DEFAULT_COLUMN_ORDER } from 'src/routes/widgets/LocatesV2Widget/columns';
import type { LocatesV2ColumnId } from 'src/routes/widgets/LocatesV2Widget/columns';

export interface ActiveColumnFilter extends ColumnFilter {
    key: string;
    columnId: LocatesV2ColumnId;
    label: string;
}

export function getActiveColumnFilters(filters: ColumnFilters): ActiveColumnFilter[] {
    return DEFAULT_COLUMN_ORDER.flatMap((columnId) =>
        (filters[columnId] ?? []).flatMap(({ mode, value }) => {
            const trimmed = value.trim();
            return trimmed
                ? [
                      {
                          columnId,
                          mode,
                          value,
                          key: JSON.stringify([columnId, mode, value]),
                          label: `${COLUMN_LABELS[columnId]} ${mode === 'include' ? 'includes' : 'excludes'}: ${trimmed}`,
                      },
                  ]
                : [];
        }),
    );
}
